<template>
    <div class="md-custom-code html-code" v-if="html" :style="{ marginBottom, minHeight }">
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileNoMargin="mobileNoMargin"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
            noMargin
        >
            <renderHtml
                class="custom-code-html-content"
                :innerHTML="html"
            />
        </module-box>
    </div>
</template>

<script>

import common from '../index';


export default {
    mixins: [common],
};
</script>

<style lang="scss">
.md-custom-code.html-code{
    p, h1, h2, ul, ol, figure, li{
        padding: revert;
    }
    ul, li{
        list-style: revert;
    }
}
</style>
